export default __webpack_public_path__ + "static/media/lifesatisfaction4Img2.9822c853.png";